<div class="grid grid-cols-12 gap-6 p-3 mb-5 bg-gray-50">
  <div class="col-span-12 lg:col-span-6 border-l-4 border-gray-700 pl-4">
    <div class="grid">
      <p class="text-xs uppercase text-gray-500 font-medium tracking-wide">
        Dashboard Section
      </p>
      <h2 class="text-xl font-bold text-nowrap text-gray-700 leading-tight">
        {{ currentViewTitle }}
      </h2>
    </div>
  </div>
</div>

<!-- Main grid -->
<div class="grid grid-cols-12 gap-6 px-8 pb-8 bg-gray-50 min-h-screen">
  <!-- Left side -->
  <div
    class="col-span-12 lg:col-span-9"
    [ngClass]="{ 'mt-[1.4rem]': !showDropdowns }"
  >
    <div class="grid grid-cols-12 gap-4">

      <ng-container *ngIf="showDropdowns">
        <!-- Website Dropdown -->
        <div class="col-span-12 lg:col-span-4">
          <label class="block text-sm mb-1">Website</label>
          <select
            class="cursor-pointer w-full border border-gray-300 rounded-lg p-2.5 text-gray-700"
            [ngModel]="selectedSiteId"
            (ngModelChange)="onSiteChange($event)"
          >
            <option value disabled>Select a site</option>
            <option *ngFor="let site of sites" [ngValue]="site.ID">
              {{ site?.Domain }}
            </option>
          </select>
        </div>

        <!-- Platform Dropdown -->
        <div class="col-span-12 lg:col-span-4">
          <label class="block text-sm mb-1">Platform</label>
          <select
            class="cursor-pointer w-full border border-gray-300 rounded-lg p-2.5 text-gray-700"
            [ngModel]="selectedPlatformId"
            (ngModelChange)="onPlatformChange($event)"
          >
            <option value disabled>Select a platform</option>
            <option
              *ngFor="let platform of filteredPlatforms"
              [ngValue]="platform.id"
            >
              {{ platform?.platform }}
            </option>
          </select>
        </div>

        <!-- Comparison Dropdown -->
        <div class="col-span-12 lg:col-span-4">
          <label class="block text-sm mb-1">Comparison</label>
          <select
            class="cursor-pointer w-full border border-gray-300 rounded-lg p-2.5 text-gray-700"
            [(ngModel)]="selectedPeriod"
            (ngModelChange)="onPeriodChange($event)"
          >
            <option [ngValue]="'days_28'">Last 30d</option>
            <option [ngValue]="'week'">Last 7d</option>
          </select>
        </div>
      </ng-container>

      <!-- Metric cards -->
      <ng-container
        *ngIf="isLoaded && isMetricsLoaded && activeView !== 'trends' && activeView !== 'format' && activeView !== 'alerts'"
      >
        <div class="col-span-6 xl:col-span-3 bg-white border border-gray-300 rounded-lg p-4 text-center">
          <ng-container
            *ngIf="lastChartValue !== null && diffChartValue !== null; else noData"
          >
            <p class="text-sm">Followers</p>
            <p class="text-2xl font-bold">
              {{ lastChartValue | number }}
            </p>
            <p
              class="text-xs mt-1"
              [ngClass]="{
                'text-green-500': diffChartValue > 0,
                'text-red-500': diffChartValue < 0,
                'text-gray-500': diffChartValue === 0
              }"
            >
              {{ diffChartValue > 0 ? '+' + diffChartValue : diffChartValue }}
            </p>
          </ng-container>
          <ng-template #noData>
            <p class="text-gray-400 text-sm italic py-6">Data not found</p>
          </ng-template>
        </div>

        <div class="col-span-6 xl:col-span-3 bg-white border border-gray-300 rounded-lg p-4 text-center">
          <ng-container
            *ngIf="isMetricsLoaded && metrics.reach.value !== 0; else noData"
          >
            <p class="text-sm">Account Reach</p>
            <p class="text-2xl font-bold">
              {{ metrics.reach.value | number }}
            </p>
            <p
              class="text-xs mt-1"
              [ngClass]="{
                'text-green-500': metrics.reach.diff > 0,
                'text-red-500': metrics.reach.diff < 0,
                'text-gray-500': metrics.reach.diff === 0
              }"
            >
              {{ metrics.reach.diff > 0 ? '+' + (metrics.reach.diff | number) : (metrics.reach.diff | number) }}
            </p>
          </ng-container>
        </div>

        <div class="col-span-6 xl:col-span-3 bg-white border border-gray-300 rounded-lg p-4 text-center">
          <ng-container
            *ngIf="metrics.accountImpressions.value !== null && metrics.accountImpressions.value !== 0; else noData"
          >
            <p class="text-sm text-nowrap">Account Impressions</p>
            <p class="text-2xl font-bold">
              {{ metrics.accountImpressions.value | number }}
            </p>
            <p
              class="text-xs mt-1"
              [ngClass]="{
                'text-green-500': metrics.accountImpressions.diff > 0,
                'text-red-500': metrics.accountImpressions.diff < 0,
                'text-gray-500': metrics.accountImpressions.diff === 0
              }"
            >
              {{ metrics.accountImpressions.diff > 0 ? '+' + (metrics.accountImpressions.diff | number) : (metrics.accountImpressions.diff | number) }}
            </p>
          </ng-container>
        </div>

        <div class="col-span-6 xl:col-span-3 bg-white border border-gray-300 rounded-lg p-4 text-center">
          <ng-container
            *ngIf="metrics.profileImpressions.value !== null && metrics.profileImpressions.value !== 0; else noData"
          >
            <p class="text-sm">Profile Impressions</p>
            <p class="text-2xl font-bold">
              {{ metrics.profileImpressions.value | number }}
            </p>
            <p
              class="text-xs mt-1"
              [ngClass]="{
                'text-green-500': metrics.profileImpressions.diff > 0,
                'text-red-500': metrics.profileImpressions.diff < 0,
                'text-gray-500': metrics.profileImpressions.diff === 0
              }"
            >
              {{ metrics.profileImpressions.diff > 0 ? '+' + (metrics.profileImpressions.diff | number) : (metrics.profileImpressions.diff | number) }}
            </p>
          </ng-container>
        </div>
      </ng-container>

      <!-- Dynamic Chart Area -->
      <div
        *ngIf="isLoaded"
        class="col-span-12 bg-white border border-gray-200 rounded-lg p-5"
      >
        <app-social-ai-follower-growth-chart
          *ngIf="activeView === 'followers'"
          [title]="'Follower Growth'"
        >
        </app-social-ai-follower-growth-chart>

        <app-social-ai-trends-chart
          *ngIf="activeView === 'trends'"
          [selectedSiteId]="selectedSiteId"
          [selectedPlatformId]="selectedPlatformId"
          [selectedPeriod]="selectedPeriod"
          [pages]="pages"
        >
        </app-social-ai-trends-chart>

        <app-social-ai-alerts-chart *ngIf="activeView === 'alerts'">
        </app-social-ai-alerts-chart>
      </div>
    </div>
  </div>

  <!-- Right side -->
  <div class="col-span-12 lg:col-span-3 mt-[1.4rem]">
    <div class="grid grid-cols-12 gap-4 items-start">

      <!-- Dynamic cards -->
      <ng-container *ngFor="let card of getRightCards()">
        <div
          class="col-span-12 bg-white border border-gray-300 rounded-lg p-4 shadow-sm transition-all duration-300 cursor-pointer hover:shadow-md hover:scale-[1.02]"
          (click)="card.action()"
        >
          <h3 class="text-gray-700 mb-2">{{ card.title }}</h3>
          <div class="bg-blue-50 rounded mb-2 grid place-items-center text-gray-400 text-xs">
            <img [src]="card.img" alt class="object-contain w-full h-full" />
          </div>
          <p *ngIf="card.diff" class="text-green-600 text-xs font-semibold">
            {{ card.diff }}
          </p>
          <p>
            <a
              (click)="card.action()"
              class="text-gray-800 text-xs cursor-pointer"
            >
              View this metric
            </a>
          </p>
        </div>
      </ng-container>

      <!-- Latest posts -->
      <div class="col-span-12" *ngIf="posts.length > 0">
        <div>
          <div class="mb-3 flex items-center justify-between">
            <h3 class="text-gray-700 mb-2">Latest Posts</h3>
          </div>

          <ng-container *ngFor="let p of posts | slice:0:maxSidebarCards; trackBy: trackById">
            <article
              class="bg-white/90 border border-gray-200 rounded-2xl p-1 sm:p-1.5 shadow-sm
                    transition-all duration-200 hover:bg-white hover:shadow-lg hover:-translate-y-0.5"
            >
              <div class="flex flex-col gap-1 sm:gap-1">
                <div class="flex items-stretch gap-3">
                  <div class="shrink-0 w-28">
                    <button
                      type="button"
                      class="aspect-video w-full overflow-hidden rounded-md bg-gray-100
                            focus:outline-none focus:ring-2 focus:ring-blue-200"
                      (click)="viewRow(p)"
                      [attr.aria-label]="'Open ' + (p.rss_title || 'post')"
                    >
                      <img
                        class="w-full h-full object-cover"
                        [src]="p.image_url || naPlaceholder"
                        alt="{{ p.rss_title || 'Post image' }}"
                        (error)="onMainImgError($event)"
                      />
                    </button>
                  </div>

                  <div class="min-w-0 flex-1 flex flex-col">
                    <div
                      role="heading"
                      aria-level="3"
                      class="text-[13px] sm:text-[14px] font-normal text-gray-900 leading-snug
                            line-clamp-2 sm:line-clamp-3"
                      [matTooltip]="p.rss_title"
                    >
                      {{ p.rss_title || '—' }}
                    </div>
                  </div>
                </div>

                <div class="flex items-center gap-3 text-[11px] text-gray-600">
                  <div class="shrink-0 w-28 flex items-center justify-center">
                    <span
                      class="truncate px-1 text-[10px] font-medium
                            text-gray-500 uppercase tracking-wide"
                      [title]="p.domain_name || '—'"
                    >
                      {{ p.domain_name || '—' }}
                    </span>
                  </div>

                  <div class="flex-1 flex items-center gap-2">
                    <span
                      *ngIf="p.social_platform_title as plat"
                      class="inline-flex items-center justify-center px-2 py-0.5 rounded-full
                            border border-gray-200 bg-gray-50 max-w-[9rem] truncate text-[11px] font-medium"
                      [ngClass]="platformTextClass(plat)"
                      [title]="plat"
                    >
                      {{ plat }}
                    </span>

                    <button
                      type="button"
                      class="inline-flex items-center justify-center px-2 py-0.5 rounded-full
                            border border-gray-200 bg-transparent text-gray-700 text-[11px] font-medium
                            hover:bg-gray-50 hover:text-gray-900 focus:outline-none focus:ring-1 focus:ring-gray-200"
                      (click)="viewRow(p); $event.stopPropagation()"
                    >
                      View
                    </button>
                  </div>
                </div>
              </div>
            </article>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>